import { Component, OnInit, ViewChild } from '@angular/core';
import { DxDataGridComponent } from 'devextreme-angular';
import { ArkUnitOfWork, UtilityService } from '../../core/core.module';
import { UserDetailComponent } from '../user-detail/user-detail.component';
import { BsModalService } from 'ngx-bootstrap/modal';
import { SharedModule } from '../../shared/shared.module';
import { InputDialogComponent } from '../../shared/input-dialog/input-dialog.component';
import { User } from 'app/core/model/entity-model';

@Component({
    selector: 'app-user-list',
    templateUrl: './user-list.component.html',
    styleUrls: ['./user-list.component.scss'],
    standalone: false,
})
export class UserListComponent implements OnInit {
    users: any[] = [];
    entities: any;
    filter: any;
    showAll = false;

    @ViewChild('searchGrid') searchGrid: DxDataGridComponent;
    onToolbarPreparing = SharedModule.onToolbarPreparing;

    constructor(private uow: ArkUnitOfWork, private modalService: BsModalService, private utility: UtilityService) {}

    async ngOnInit() {
        await this.getData();
        this.filter = {};
    }

    async getData() {
        const entities = (await this.uow.getUsers({ expand: 'userRoles.role', orderby: 'userName' })) as User[];
        if (this.showAll) this.entities = entities;
        else
            this.entities = entities.filter((x) => {
                return !x.inactive;
            });
    }

    async toggleShowAll() {
        this.showAll = !this.showAll;
        await this.getData();
    }

    async rowDoubleClick(e) {
        await this.open(e.data);
    }

    async open(user?: any) {
        const modalRef = this.modalService.show(UserDetailComponent, {
            class: 'modal-sm',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                key: user ? user.id : null,
            },
        });

        modalRef.content.result.subscribe(async (result) => {
            modalRef.hide();
            if (result && result.success) {
                await this.getData();
            }
        });
    }
    async printVoteReport() {
        await this.utility.printNominationBallot();
    }

    async printNominationFormReport() {
        const endDate = await this.getInput('Enter due date', 'date', null, new Date());
        if (!endDate) return;
        await this.utility.printNominationForm(endDate);
    }

    async getInput(prompt: string, mode: string, array?: any[], value?: any): Promise<any> {
        let modalRef = this.modalService.show(InputDialogComponent, {
            class: 'modal-sm',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                dialogHeader: 'Graafschap Church',
                dialogPrompt: prompt,
                dialogValueArray: array,
                dialogValue: value,
                mode: mode,
            },
        });
        const promise = new Promise<any>(async (resolve, reject) => {
            modalRef.content.result.subscribe(async (result) => {
                if (result.success) {
                    resolve(result.value);
                }
                modalRef.hide();
                resolve(null);
            });
        });
        return promise;
    }
}
